// extracted by mini-css-extract-plugin
module.exports = {"actionbar":"EditorActionbar_actionbar__30PHf"};